import type { EventModel } from "./EventModel";
import type {
  Event,
  EventParticipant,
  CreateEventRequest,
  UpdateEventRequest,
  RegisterParticipantRequest,
} from "./Event.typed";

export class EventAdapter {
  constructor(private model: EventModel) {}

  async getEvents(): Promise<Event[]> {
    return this.model.getEvents();
  }

  async getEvent(id: number): Promise<Event> {
    return this.model.getEvent(id);
  }

  async createEvent(event: CreateEventRequest): Promise<Event> {
    return this.model.createEvent(event);
  }

  async updateEvent(event: UpdateEventRequest): Promise<Event> {
    return this.model.updateEvent(event);
  }

  async deleteEvent(id: number): Promise<void> {
    return this.model.deleteEvent(id);
  }

  async getEventParticipants(eventId: number): Promise<EventParticipant[]> {
    return this.model.getEventParticipants(eventId);
  }

  async registerForEvent(participant: RegisterParticipantRequest): Promise<EventParticipant> {
    return this.model.registerForEvent(participant);
  }

  async deleteEventParticipant(eventId: number, participantId: number): Promise<void> {
    return this.model.deleteEventParticipant(eventId, participantId);
  }

  async toggleEventOnline(eventId: number, online: boolean): Promise<void> {
    return this.model.toggleEventOnline(eventId, online);
  }

  async uploadEventBackground(eventId: number, file: File): Promise<string> {
    return this.model.uploadEventBackground(eventId, file);
  }
}
